import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Box,
  Text,
  Tag,
  SimpleGrid,
  Button,
  Icon,
  Heading,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Skeleton,
  SkeletonText,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Stack,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { FiArrowLeft } from "react-icons/fi";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { MdDelete, MdEditNote } from "react-icons/md";
import Card from "components/card/Card.js";
import { GetRoles, DeleteRole } from "services/roleService";

export default function Roles() {
  const userState = useSelector((state) => state?.user?.value);
  const token = userState.hasOwnProperty("token") ? userState.token : null;
  const privileges = userState.hasOwnProperty("privileges") ? userState.privileges : [];
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [loading, setLoading] = useState(false);

  const [roles, setRoles] = useState(null);
  const [roleId, setRoleId] = useState("");

  const toast = useToast();

  const getRoles = async () => {
    try {
      setLoading(true);
      /*if (!privileges.includes("Admin")) {
        toast({
          title: "You are not allowed",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }*/
      const response = await GetRoles(token);
      setLoading(false);
      if (response.error || !response.success) {
        toast({
          id: response.error ? response.error : (response.message ? response.message : "api-error"),
          title: response.error ? response.error : (response.message ? response.message : "An error occured"),
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }
      if (response.success) {
        setRoles(response?.data);
      }
    } catch (error) {
      setLoading(false);
      toast({
        id: error.message || "api-error",
          title: error.message || "An error occured",
        status: "error",
        duration: 9000,
        position: "top-right",
        isClosable: true,
      });
    }
  };

  const deleteRole = async () => {
    try {
      setLoading(true);
      /*if (!privileges.includes("Admin")) {
        toast({
          title: "You are not allowed",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }*/
      const response = await DeleteRole(roleId, token);
      setLoading(false);
      if (response.error || !response.success) {
        toast({
          id: response.error ? response.error : (response.message ? response.message : "api-error"),
          title: response.error ? response.error : (response.message ? response.message : "An error occured"),
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }
      if (response.success) {
        toast({
          title: response.message || "Role deleted successfully",
          status: "success",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        getRoles();
        onClose();
      }
    } catch (error) {
      toast({
        id: error.message || "api-error",
          title: error.message || "An error occured",
        status: "error",
        duration: 9000,
        position: "top-right",
        isClosable: true,
      });
      setLoading(false);
    }
  };

  const getPrivileges = (privileges) => {
    const privys = privileges && privileges.length > 0 ? privileges : [];
    return privys.map((priv, index) => {
      return (
        <Tag fontSize="13" key={index} background="brand.500" color="white" ml="1">
          {priv}
        </Tag>
      );
    });
  };

  useEffect(() => {
    getRoles();
  }, []);

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size={"md"}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Icon
              as={FiArrowLeft}
              onClick={onClose}
              width="20px"
              height="20px"
            />
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <SimpleGrid>
              <Box textAlign="center">
                <Heading
                  fontSize={{ base: "md", sm: "lg", md: "lg", lg: "xl" }}
                >
                  Are you sure you want to delete this?
                </Heading>
              </Box>
            </SimpleGrid>
          </ModalBody>

          <ModalFooter>
            <Button
              variant="primary"
              background="#000000"
              isLoading={loading}
              loadingText="Please Wait"
              onClick={(e) => {
                e.preventDefault();
                deleteRole();
              }}
            >
              Proceed
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Box mt={{ sm: "40px", md: "80px" }} width="100%" mb="70">

        <SimpleGrid
          width="100%"
          columns={{ base: 2, md: 2 }}
          spacing="2"
          mt="4"
          mb="15"
        >
          <Box mb="5">
            {" "}
            <Text
              color={"black"}
              mb="4px"
              fontFamily={"ManropeSemiBold"}
              fontSize={{ base: "md", sm: "lg", md: "xl", lg: "2xl" }}
            > Roles
            </Text>
          </Box>
          <Box width="100%" textAlign="right">
            <Button
              colorScheme="teal"
              background="black"
              color="#ffffff"
              _hover={{ color: "brand.500", background: "black" }}
              size="md"
              onClick={() => {
                navigate("/admin/settings/addrole");
              }}
            >
              Add Role
            </Button>
          </Box>
        </SimpleGrid>


        {loading ? (
          <Loading />
        ) : (
          <TableContainer>
            <Table variant="striped" fontSize={{ sm: "md", md: "lg" }}>
              <Thead>
                <Tr>
                  <Th color="#000000">Role Name</Th>
                  <Th color="#000000">Role Abbreviation</Th>
                  <Th color="#000000">privileges</Th>
                  <Th color="#000000">Action</Th>
                </Tr>
              </Thead>
              <Tbody>
                {roles !== null &&
                  roles.map((role) => (
                    <Tr>
                      <Td>{role.roleName}</Td>
                      <Td>{role.roleAbbreviation}</Td>
                      <Td>
                        {getPrivileges(role.privileges)}
                      </Td>
                      <Td>
                        {" "}
                        <Menu>
                          <MenuButton
                            as={Button}
                            variant="primary"
                            background="#000000"
                            rightIcon={<ChevronDownIcon />}
                          >
                            Action
                          </MenuButton>
                          <MenuList>
                            <MenuItem
                              onClick={() => {
                                navigate("/admin/settings/addrole/" + role._id, {
                                  state: { roleId: role._id },
                                });
                              }}
                            >
                              Edit &nbsp;{" "}
                              <Icon
                                as={MdEditNote}
                                width="20px"
                                height="20px"
                                color="#000000"
                              />{" "}
                            </MenuItem>
                            <MenuItem
                              onClick={() => {
                                setRoleId(role._id);
                                onOpen();
                              }}
                            >
                              Delete &nbsp;{" "}
                              <Icon
                                as={MdDelete}
                                width="20px"
                                height="20px"
                                color="#000000"
                              />{" "}
                            </MenuItem>
                          </MenuList>
                        </Menu>
                      </Td>
                    </Tr>
                  ))}
              </Tbody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </>
  );
}

const Loading = () => {
  return (
    <>
      <Card align="center" p="5px">
        <Stack>
          <Skeleton height="5px" />
          <SkeletonText mt="2" noOfLines={3} spacing="3" />
          <Skeleton height="5px" />
        </Stack>
      </Card>

      <Card align="center" p="5px" mt="5">
        <Stack>
          <Skeleton height="5px" />
          <SkeletonText mt="2" noOfLines={3} spacing="3" />
          <Skeleton height="5px" />
        </Stack>
      </Card>
    </>
  );
};
